import { useStoreInfo } from "../../../hooks/storeInfoHooks/useStoreInfo";
import { FaXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

const MobileWidgets = () => {
  const { data: storeInfo, isLoading: isLoadingStoreInfo } = useStoreInfo();

  return (
    <div className="offcanvas-widget-area mt-5">
      <div className="off-canvas-contact-widget">
        <div className="header-contact-info">
          <ul className="header-contact-info__list">
            <li>
              <i className="fa fa-phone fs-5"></i>
              <a
                href={`tel:${storeInfo?.[0]?.phone}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {storeInfo?.[0]?.phone}{" "}
              </a>
            </li>
            <li>
              <i className="fa fa-envelope fs-5"></i>
              <a
                href={`mailto:${storeInfo?.[0]?.email}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                {storeInfo?.[0]?.email}
              </a>
            </li>
            <li>
              {" "}
              <i className="fa fa-map fs-5"></i>
              <a href={"/"}>{storeInfo?.[0]?.address}</a>
            </li>
          </ul>
        </div>
      </div>
      {/*Off Canvas Widget Social Start*/}
      <div className="d-flex align-items-center gap-3 footer-list flex-wrap justify-content-center">
        {storeInfo?.[0]?.facebook && (
          <a href={storeInfo?.[0]?.facebook} target="_blank">
            <FaFacebookF size={20}></FaFacebookF>
          </a>
        )}
        {storeInfo?.[0]?.twitter && (
          <a href={storeInfo?.[0]?.twitter} target="_blank">
            <FaXTwitter size={20}></FaXTwitter>
          </a>
        )}
        {storeInfo?.[0]?.youtube && (
          <a href={storeInfo?.[0]?.youtube} target="_blank">
            <IoLogoYoutube size={20}></IoLogoYoutube>
          </a>
        )}
        {storeInfo?.[0]?.instagram && (
          <a href={storeInfo?.[0]?.instagram} target="_blank">
            <FaInstagram size={20}></FaInstagram>
          </a>
        )}
        {storeInfo?.[0]?.whatsapp && (
          <a href={storeInfo?.[0]?.whatsapp} target="_blank">
            <FaWhatsapp size={20}></FaWhatsapp>
          </a>
        )}
      </div>
      {/*Off Canvas Widget Social End*/}
    </div>
  );
};

export default MobileWidgets;
